import React, { useContext, useEffect, useState } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import EmployeeProfileStore from "../../../app/stores/employeeProfileStore";
import { observer } from "mobx-react-lite";
import { Card, Table, Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Link } from "react-router-dom";

const EmployeeDetails: React.FC = ({}) => {
  const employeeProfileStore = useContext(EmployeeProfileStore);
  const { employee, loadEmployeeProfile, loadingInitial } =
    employeeProfileStore;

  useEffect(() => {
    loadEmployeeProfile();
  }, []);

  if (loadingInitial || !employee)
    return <LoadingComponent content="Loading Employee ..." />;

  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          <h2>{employee!.name}</h2>
        </Card.Header>
        <Table definition>
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>Email</Table.Cell>
              <Table.Cell>{employee!.email}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Preferred Name</Table.Cell>
              <Table.Cell>{employee!.preferredName}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Status</Table.Cell>
              <Table.Cell>{employee!.status}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Department</Table.Cell>
              <Table.Cell>{employee!.department}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Position</Table.Cell>
              <Table.Cell>{employee!.position}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Mobile</Table.Cell>
              <Table.Cell>{employee!.mobile}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Address</Table.Cell>
              <Table.Cell>{employee!.address}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Date of Birth</Table.Cell>
              <Table.Cell>{employee!.dob}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Start Date</Table.Cell>
              <Table.Cell>{employee!.startDate}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Company Email</Table.Cell>
              <Table.Cell>{employee!.companyEmail}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Worker ID</Table.Cell>
              <Table.Cell>{employee!.workerId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Type</Table.Cell>
              <Table.Cell>{employee!.type}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Australian Residency</Table.Cell>
              <Table.Cell>{employee!.australianResidency}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>NBN Enable ID</Table.Cell>
              <Table.Cell>{employee!.nbnEnableId}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>USI</Table.Cell>
              <Table.Cell>{employee!.usi}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>Remark</Table.Cell>
              <Table.Cell>{employee!.remark}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Content>

      <Card.Content extra>
        <Button.Group widths={2}>
          <Button
            as={Link}
            to={"/employeeportal/profile-edit"}
            basic
            color="blue"
            content="Edit"
          />
        </Button.Group>
      </Card.Content>
    </Card>
  );
};

export default observer(EmployeeDetails);
